import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

const Image = ({ src }: any) => (
	<Box sx={styles.image}>
		<Box component={'img'} src={src} sx={styles.fill} />
	</Box>
)

const Text = ({ children }: any) => <Box sx={styles.text}>{children}</Box>

const Group = ({ image, children, reverse = false }: any) => {
	const nodes = [
		<Grid item md={6} key={`${image}-0`}>
			<Image src={image} />
		</Grid>,
		<Grid item md={6} key={`${image}-1`}>
			<Text>
				<Typography variant="body1">{children}</Typography>
			</Text>
		</Grid>
	]

	const display = reverse ? nodes.reverse() : nodes

	return <>{display.map((node: any) => node)}</>
}

export default function Marketing({ isMobile }: any) {
	return (
		<>
			<Grid container spacing={6}>
				<Grid item md={12}>
					<Typography variant="h2" textAlign={'center'}>
						<Box component="span" sx={{ fontSize: '3.5rem' }}>
							Why Choose Our
						</Box>
						<br />
						Chicken & Grains Recipe?
					</Typography>
				</Grid>
				<Group image="https://static.wixstatic.com/media/1b43b4_c177ed12d03b4cc1a358eb85373c9c6a~mv2.jpg">
					Breakfast and dinner will never be the same again. Your dog will love our Chicken & Grains
					Recipe.
				</Group>

				<Group
					image="https://static.wixstatic.com/media/1b43b4_de82b449c35f4cc0b555d47f922e8500~mv2.jpg"
					reverse={!isMobile}
				>
					Dogs go crazy over our food. They can't get enough of it. They'll be begging for more.
				</Group>

				<Group image="https://static.wixstatic.com/media/1b43b4_f94d7f3dc7424952aaa065307026db8c~mv2.jpg">
					Every last bite will be gone. Your dog will be licking the bowl clean. They'll be so
					happy.
				</Group>

				<Group
					image="https://static.wixstatic.com/media/1b43b4_c8bf7d2c6a42428081bc65d42644898d~mv2.jpg"
					reverse={!isMobile}
				>
					They're already part of the family. They deserve the best. Give them the best. Give them
					our Chicken & Grains Recipe.
				</Group>
			</Grid>
		</>
	)
}

const styles = {
	image: {
		borderRadius: 2,
		overflow: 'hidden'
	},
	fill: {
		width: '100%',
		height: '100%',
		objectFit: 'cover'
	},
	text: {
		display: 'flex',
		height: '100%',
		alignItems: 'center',
		width: {
			md: '60%'
		}
	},
	promote: {
		root: {
			position: 'relative',
			backgroundColor: '#fff2e1',
			// pt: 15,
			pb: 15
		}
	}
}
